import { FOfferType, isAvailable, FDealType } from '../../../../../../../packages/JsonQuery';
import { IFilterSet, TAllFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.Garage;

export const GARAGE_FILTERS_SET: IFilterSet<TAllFilter>[] = [
  {
    availability: isAvailable(FDealType.Sale, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'publicationDate',
      'electronicTrading',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, OFFER_TYPE),
    list: [
      'dealType',
      'objectType',
      'price',
      'undergroundTime',
      'squareMeterArea',
      'garageType',
      'garageStatus',
      'garageUtilities',
      'parking',
      'electronicTrading',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
];
